module.exports = __webpack_public_path__ + "static/media/md.b36bf434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/md.png
// module id = 1917
// module chunks = 0